import React, { Component } from "react";
import SingleBasketProduct from "../SingleBasketProduct/SingleBasketProduct";
import Loader from "../../common/Loader";
import ActionButtons from "../ActionButtons/ActionButtons";
import Api from "../../common/helpers/Api";
import ProductSuggestions from "../ProductSuggestion/ProductSuggestions";
export default class Basket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // loginStatusLoading: true,
      loading: true,
      purchasedProducts: [],
      refreshCartLoading: false,
      sale: null,
      articles: []
    };
  }

  async componentDidMount() {
    await this.props.store.getLoginStatus();
    // this.setState({ loginStatusLoading: false });
  }
  async componentDidUpdate(prevProps) {

    const purchasesResponse = await this.getPurchases();
    console.log("purchasesResponse", purchasesResponse.purchases);

    purchasesResponse.purchases.map((purchase) => {
      this.state.purchasedProducts.push(purchase.productCode);
    });

    if (
      (prevProps.store.contactUser !== this.props.store.contactUser &&
        this.props.store.contactUser !== null) ||
      (prevProps.store.isLoggedIn === false &&
        this.props.store.isLoggedIn === true)
    ) {
      // Et son panier si il y en a un, ou on en crée un
      const sale = await this.props.store.getUserCart(false);
      console.log("sale", sale);
      if (this.props.store.cartId === null) {
        this.setState({ loading: false, sale });
      } else {
        const articles = await this.getArticlesFromCart(
          this.props.store.cartId
        );
        if (articles.error !== undefined && articles.error === null) {
          this.setState({
            sale,
            articles: articles.articles,
            loading: false
          });
        } else {
          this.setState({ sale, articles: [], loading: false });
        }
      }
    }
  }

  async getPurchases() {
    try {
      const response = await Api.get("articles", {
        params: {
          "sale.contactId": this.props.store.contactUser.contactId,
          "sale.state": "sale", // Ventes conclues
          itemsPerPage: 200,
          "order[createdAt]": "desc",
        },
      });
      const { data } = response;
      return { error: null, purchases: data["hydra:member"] };
    } catch (error) {
      console.log(error);
      return { error: "Une erreur s'est produite" };
    }
  }

  async getArticlesFromCart(cartId) {
    if (!cartId) {
      return { articles: [] };
    }

    try {
      const response = await Api.get("articles", {
        params: {
          sale: cartId
        }
      });
      const { data } = response;

      if (data["hydra:member"])
        return { articles: data["hydra:member"], error: null };
      else return { error: null, articles: [] };
    } catch (reason) {
      if (reason.response) {
        if (reason.response.status === 400) {
          return { error: "Identifiants inconnus" };
        } else {
          return { error: "Une erreur s'est produite" };
        }
      }
    }
  }

  async refreshCart() {
    if (!this.state.refreshCartLoading)
      this.setState({ refreshCartLoading: true });

    const sale = await this.props.store.getUserCart(false);
    if (this.props.store.cartId === null) {
      this.setState({ refreshCartLoading: false, sale });
    } else {
      const articles = await this.getArticlesFromCart(this.props.store.cartId);

      if (articles.error !== undefined && articles.error === null) {
        await this.setState({
          sale,
          articles: articles.articles,
          refreshCartLoading: false
        });
      } else {
        this.setState({ sale, articles: [], refreshCartLoading: false });
      }
    }
  }

  render() {
    const { store, checkout } = this.props;
    const { sale, articles, loading, refreshCartLoading } = this.state;

    // IF cart has a specific plan, we don't show the suggestions
    const hasSpecificPlan = articles && articles.length > 0 && articles.filter((article) => article && (article.productName.includes('PLAN'))).length > 0;
    return (
      <>
        <div className="holder">
          {loading ? (
            <Loader color="#e64117" />
          ) : (
            <div
              className={"product-container"}
              style={
                refreshCartLoading
                  ? { pointerEvents: "none", opacity: "0.4" }
                  : {}
              }
            >
              {articles && articles.length > 0 && <h5>Votre panier</h5>}
              {hasSpecificPlan && <p style={{textAlign: 'left', fontSize: '1rem', marginTop: 40, marginBottom: 60}}>Les plans sont établis pour être réalisés dans la salle sport santé MON STADE. Vous pouvez choisir de faire tout ou partie de votre plan d’entraînement avec nos enseignants en APA. Aucune adaptation avec votre matériel à domicile ne sera possible.</p>}
              <div className="products">
                {articles && articles.length > 0 && (
                  <div className="product product-header">
                    <div className="product--details--left">
                      <p className="product--name">Produit</p>
                      {/* <p className="product--description">Description</p> */}
                    </div>
                    <div className="product--details--right">
                      <div className="product--price">
                        <span>Prix</span>
                      </div>

                      <div className="product--delete">
                        <p>Suppr.</p>
                      </div>
                    </div>
                  </div>
                )}
                {articles && articles.length ? (
                  articles.map(p => {
                    return (
                      <SingleBasketProduct
                        key={p["@id"]}
                        store={store}
                        product={p}
                        stopRefreshCart={() =>
                          this.setState({ refreshCartLoading: false })
                        }
                        willRefreshCart={() =>
                          this.setState({
                            refreshCartLoading: true
                          })
                        }
                        refreshCart={this.refreshCart.bind(this)}
                      />
                    );
                  })
                ) : (
                  <p className="basket-is-empty">
                    {" "}
                    <i className="fa fa-shopping-cart" aria-hidden="true" /> Le
                    panier est vide
                  </p>
                )}
              </div>
              {articles && articles.length > 0 && (
                <>
                  <ProductSuggestions
                    store={store}
                    articles={articles}
                    willRefreshCart={() =>
                      this.setState({
                        refreshCartLoading: true
                      })
                    }
                    refreshCart={this.refreshCart.bind(this)}
                  />
                  <div className={"basket-summary"}>
                    {/* <p>
                    {articles.length} Produit{articles.length > 1 && "s"}
                  </p>{" "} */}
                    <p>Total</p>
                    <p>{sale.totalTI / 100}€</p>
                  </div>
                  <ActionButtons
                    keepNavigating={this.props.keepNavigating || false}
                    checkoutBtn={this.props.checkoutBtn || true}
                    popupName={this.props.popupName}
                    store={store}
                    articles={articles}
                    purchasedProducts={this.state.purchasedProducts}
                  />
                </>
              )}
            </div>
          )}
        </div>
      </>
    );
  }
}
